module.exports = __webpack_public_path__ + "img/bg_comments.0387df04.png";